import { Apis } from "../../lib/Apis";

export const useUser = () => {
  const getAllUsers = async (setUsersData, offset = 0, limit = 9) => {
    try {
      const response = await Apis.getAllUsers(offset, limit);
      const payload = response?.data?.data || {};
      setUsersData(payload.users || []);
      return payload;
    } catch (error) {
      console.error(
        "🚀 ~ file: useHook.js ~ line 64 ~ getAllUsers ~ error",
        error,
      );
      return error;
    }
  };
  const updateUserStatus = async (id, status) => {
    try {
      const requestBody = {
        id,
        status,
      };
      const response = await Apis.updateUSerStatus(requestBody);
      return response?.data;
    } catch (error) {
      console.error("Error in Hook:", error.message || error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to update user status.",
      );
    }
  };
  const searchUsers = async (
    searchQuery,
    emailQuery,
    statusFilter,
    offset = 0,
    limit = 9,
  ) => {
    try {
      const params = {
        offset,
        limit,
      };

      if (statusFilter !== "") {
        params.status = statusFilter === "true" ? true : false;
      }

      if (searchQuery) {
        params.name = searchQuery;
      }

      if (emailQuery) {
        params.email = emailQuery;
      }

      const response = await Apis.searchUsers(params);
      return response?.data?.data || { users: [], pagination: {} };
    } catch (error) {
      console.error(
        "🚀 ~ file: useHook.js ~ line 64 ~ searchUsers ~ error",
        error,
      );
      return error;
    }
  };

  return { getAllUsers, updateUserStatus, searchUsers };
};

export const useBankAccount = () => {
  const getAllBankAccounts = async (setBankAccounts) => {
    try {
      const response = await Apis.getBankAccounts();
      const accounts = response?.data?.data;
      setBankAccounts(Array.isArray(accounts) ? accounts : []);
      return accounts;
    } catch (error) {
      console.error(error);
      setBankAccounts([]);
      throw error;
    }
  };

  const addBankAccount = async (data) => {
    try {
      const response = await Apis.addBankAccount(data);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to add bank account.",
      );
    }
  };

  const deleteBankAccount = async (id) => {
    try {
      const response = await Apis.delteBankAccount(id);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to delete bank account.",
      );
    }
  };

  const editBankAccountDetails = async (id, data) => {
    try {
      const response = await Apis.updateBankAccount(id, data);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to update bank account.",
      );
    }
  };

  return {
    getAllBankAccounts,
    addBankAccount,
    deleteBankAccount,
    editBankAccountDetails,
  };
};

export const usePickupPoints = () => {
  const getPickupPoints = async (setPickupPoints, offset = 0, limit = 20) => {
    try {
      const response = await Apis.getPickupPoints(offset, limit);
      const payload = response?.data?.data || {};
      setPickupPoints(payload.pickupPoints || []);
      return payload;
    } catch (error) {
      console.error(error);
      setPickupPoints([]);
      throw error;
    }
  };

  const addPickupPoint = async (data) => {
    try {
      const response = await Apis.createPickupPoint(data);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to add pickup point.",
      );
    }
  };

  const updatePickupPoint = async (id, data) => {
    try {
      const response = await Apis.updatePickupPoint(id, data);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to update pickup point.",
      );
    }
  };

  const deletePickupPoint = async (id) => {
    try {
      const response = await Apis.deletePickupPoint(id);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to delete pickup point.",
      );
    }
  };

  const togglePickupPointStatus = async (id) => {
    try {
      const response = await Apis.togglePickupPointStatus(id);
      return response?.data;
    } catch (error) {
      console.error(error);
      throw new Error(
        error?.response?.data?.message ||
          error.message ||
          "Failed to toggle pickup point status.",
      );
    }
  };

  return {
    getPickupPoints,
    addPickupPoint,
    updatePickupPoint,
    deletePickupPoint,
    togglePickupPointStatus,
  };
};

export const useUtm = () => {
  const getUtmLinks = async (setUtmLinks) => {
    try {
      const response = await Apis.getUtmLinks();
      setUtmLinks(response.data?.data || []);
      if (response.status === 200) {
        return response.data?.data || [];
      }
    } catch (error) {
      return [];
    }
  };
  const addUtm = async (data) => {
    try {
      const response = await Apis.createUtm(data);
      if (response.status === 200 || response.status === 201) {
        return response.data;
      }
    } catch (error) {
      return [];
    }
  };
  const updateUtmStatus = async (id, status) => {
    try {
      const response = await Apis.updateUtmStatus(id, status);
      if (response.status === 200) {
        return response.data;
      }
    } catch (error) {
      throw new Error("Failed to update UTM link status.");
    }
  };

  return {
    getUtmLinks,
    addUtm,
    updateUtmStatus,
  };
};
